<ag-grid-angular
  [gridOptions]="internalGridOptions"
  class="ag-theme-alpine flex-grow-1"
  [columnDefs]="columnDefs"
  [rowData]="internalGridOptions.rowModelType === 'serverSide' ? null : items"
  [floatingFiltersHeight]="floatingFiltersHeight"
  [modules]="modules"
  [rowSelection]="rowSelection"
  (selectionChanged)="onSelectionChanged($event)"
  (rowDataChanged)="onRowDataChanged($event)"
  (rowClicked)="rowClickedChanged($event)"
  (rowDoubleClicked)="rowDoubleClickedChanged($event)"
  (gridReady)="onGridReady($event)"
>
</ag-grid-angular>
